import { useNavigate } from 'react-router-dom'

import ProfileHeader from 'components/ProfileHeader'

import { LuRoute } from 'react-icons/lu'
import { FiChevronRight, FiSettings, FiCalendar, FiCrosshair } from 'react-icons/fi'
import { SlGraph } from 'react-icons/sl'

const Main = () => {
  const navigate = useNavigate()

  return <section className="one hs air-2x gap-2x">

    <ProfileHeader />

    <ul className="list-menu">
      <li className="list-item" onClick={ () => navigate( '/settings' ) }>
        <span className="icon">
          <FiSettings />
        </span>

        <span className="one text">settings</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>

      <li className="list-item" onClick={ () => navigate( '/tracks' ) }>
        <span className="icon">
          <LuRoute />
        </span>

        <span className="one text">tracks</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>

      <li className="list-item" onClick={ () => navigate( '/statistics' ) }>
        <span className="icon">
          <SlGraph />
        </span>

        <span className="one text">statistics</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>

      { /*
      <li className="list-item" onClick={ () => navigate( '/radar' ) }>
        <span className="icon">
          <FiCrosshair />
        </span>

        <span className="one text">radar</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>

      <li className="list-item" onClick={ () => navigate( '/events' ) }>
        <span className="icon">
          <FiCalendar />
        </span>

        <span className="one text">events</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>
        */ }
    </ul>
  </section>
}

export default Main
